import { call, put, select, takeLatest } from 'redux-saga/effects'
import { CadImportConstants } from '../store/cadImport.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getCadImportSelector } from '../selectors/cadImport.selector'
import { ICadImportState } from '../store/cadImport.types'
import { getPcrIdSelector } from '../../home/selectors/getPcrId.selector'
import { setRefDefaults } from '../../pickupAddress/saga/setPickupAddressDefaults.saga'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setRecAddressDefaults } from '../../destinationAddress/saga/setDestinationAddressDefaults.saga'
import { importCadData } from '../store/cadImport.actions'
import { setUnitEquipment } from '../../tripInformation/store/tripInformation.actions'
import { getCrewSelector } from '../../crew/selectors'
import { IOptionWithKey } from '../../../common/common.types'

function* setPcrDefaults() {
  try {
    const pcrId: string = yield select(getPcrIdSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    const { importedCadData }: ICadImportState = yield select(getCadImportSelector)
    const { unitEquipmentOptions } = yield select(getCrewSelector)

    const pcrDocsService = new PcrDocsService(serviceId)

    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)

    const hasPickupAddress =
      importedCadData.findIndex((cadData) => cadData.appStateLocation.includes('patient.pickupAddress')) > 0
    if (hasPickupAddress && !pcrDoc.patient?.pickupAddress) yield call(setRefDefaults, pcrDoc)

    const hasDestinationAddress =
      importedCadData.findIndex((cadData) => cadData.appStateLocation.includes('disposition')) > 0
    if (hasDestinationAddress && !pcrDoc.disposition) yield call(setRecAddressDefaults, pcrDoc)

    const unitDataPoint = importedCadData.find((cadData) => cadData.id === 'UNIT')
    if (unitDataPoint && unitDataPoint.value && unitDataPoint.value?.equipmentLevel) {
      yield put(
        setUnitEquipment(
          unitEquipmentOptions.find(
            (uEquipment: IOptionWithKey) => uEquipment.id === unitDataPoint.value.equipmentLevel
          )
        )
      )
    }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`setPcrDefaults() error: ${e}`))
  }
}

export function* preCadImport() {
  const pcrId: string = yield select(getPcrIdSelector)
  const { importedCadData }: ICadImportState = yield select(getCadImportSelector)
  try {
    if (!pcrId) return

    yield call(setPcrDefaults)
    yield put(importCadData(importedCadData))
  } catch (e) {
    yield put(throwPcrException(`preCadImport() error: ${e}`))
  }
}

export function* preCadImportSaga() {
  yield takeLatest([CadImportConstants.PRE_CAD_IMPORT], performWithMutexHOG, preCadImport)
}
